export const UPDATE_REVIEWERS_TOP_UP = "UPDATE_REVIEWERS_TOP_UP"

export const PURCHASE_REVIEWERS = "PURCHASE_REVIEWERS"
export const PURCHASE_REVIEWERS_PENDING = "PURCHASE_REVIEWERS_PENDING"
export const PURCHASE_REVIEWERS_FAILED = "PURCHASE_REVIEWERS_REJECTED"
export const PURCHASE_REVIEWERS_FULFILLED = "PURCHASE_REVIEWERS_FULFILLED"
